import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { isMobile } from 'react-device-detect';
import classnames from 'classnames';

import { buttons as Buttons, forms as Forms } from '@breezeway/brzw-components';
import SelectPill from '../select_pill';

const { LARGE, MEDIUM } = Buttons.constants.BUTTON_SIZES;
const { SECONDARY, LINK } = Buttons.constants.BUTTON_THEMES;

const BtnOrSelectWithPills = props => {
  const {
    displayButton,
    displayPills,
    labelText,
    onRemovePills,
    openModal,
    placeholderText,
    selected,
    selectOptions,
    selectValue,
    withoutBtnSelectSpaces,
  } = props;

  return (
    <div className={classnames({ 'category-adding-button__wrapper': !withoutBtnSelectSpaces })}>
      {displayButton ? (
        <Buttons.TextButton
          className={classnames({ 'category-adding-button': !withoutBtnSelectSpaces })}
          onClick={openModal}
          size={isMobile ? LARGE : MEDIUM}
          theme={isMobile ? SECONDARY : LINK}
        >
          {labelText}
        </Buttons.TextButton>
      ) : (
        <div className={classnames({ 'category-adding-button': !withoutBtnSelectSpaces })}>
          <div role="presentation" onClick={openModal}>
            <Forms.Select
              className="additional__select"
              key={selectValue || `${_.size(selected)}`}
              labelText={labelText}
              options={selectOptions}
              placeholderText={placeholderText}
              value={selectValue}
              shouldOpenModal
            />
          </div>
          {displayPills && (
            <SelectPill onClick={(element, index) => onRemovePills(index)} elements={selected} />
          )}
        </div>
      )}
    </div>
  );
};

BtnOrSelectWithPills.propTypes = {
  displayButton: PropTypes.bool,
  displayPills: PropTypes.bool,
  labelText: PropTypes.string,
  onRemovePills: PropTypes.func,
  openModal: PropTypes.func,
  placeholderText: PropTypes.string,
  selected: PropTypes.array,
  selectOptions: PropTypes.array,
  selectValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  withoutBtnSelectSpaces: PropTypes.bool,
};

BtnOrSelectWithPills.defaultProps = {
  placeholderText: 'Select...',
};

export default BtnOrSelectWithPills;
